import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import {
    Footer as LayoutFooter,
    FooterColumn,
    FooterColumns,
    SocialChannels,
    NewsletterSignUp,
    NewsletterSignUpConfirmation,
} from '@streamr/streamr-layout'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'
import Link from '../Link'
import newsletterConfirmation from './newsletter_confirmation.png'
import Display from '~shared/Display'
import urls from '~utils/urls'
import useTranslation from '~utils/useTranslation'

const UnstyledFooter = (props) => {
    const [submissionCount, setSubmissionCount] = useState(0)

    const [confirmationOpen, setConfirmationOpen] = useState(false)

    const onSuccess = useCallback(() => {
        setSubmissionCount((count) => count + 1)
        setConfirmationOpen(true)
    }, [])

    const closeConfirmation = useCallback(() => {
        setConfirmationOpen(false)
    }, [])

    const { t } = useTranslation()

    return (
        <LayoutFooter {...props}>
            <FooterColumns>
                <FooterColumn title="Discover">
                    <Link to={urls.discover.network}>
                        {t('general.network')}
                    </Link>
                    <Link to={urls.discover.dataToken}>
                        {t('general.dataToken')}
                    </Link>
                    <Link to={urls.discover.dataUnions}>
                        {t('general.dataUnions')}
                    </Link>
                    <Link to={urls.discover.marketplace}>
                        {t('general.marketplace')}
                    </Link>
                </FooterColumn>
                <FooterColumn title="Project">
                    <Link to={urls.project.about}>
                        {t('general.about')}
                    </Link>
                    <Link to={urls.project.roadmap}>
                        Roadmap
                    </Link>
                    <Link to={urls.project.ecosystem}>
                        Ecosystem
                    </Link>
                    <Link to={urls.project.papers}>
                        {t('general.papers')}
                    </Link>
                    <Link newTab href={urls.community.blog}>
                        {t('general.blog')}
                    </Link>
                </FooterColumn>
                <FooterColumn title="Developers">
                    <Link href={urls.docs.index}>
                        Docs
                    </Link>
                    <Link href={urls.developers.dataFund}>
                        Data Fund
                    </Link>
                    <Link to={urls.project.design}>
                        {t('general.designAssets')}
                    </Link>
                </FooterColumn>
                <FooterColumn title="Apps">
                    <Link href={urls.apps.networkExplorer}>
                        Network Explorer
                    </Link>
                    <Link href={urls.apps.marketplace}>
                        {t('general.marketplace')}
                    </Link>
                    <Link href={urls.apps.core}>
                        {t('general.core')}
                    </Link>
                </FooterColumn>
                <FooterColumn title="Contact">
                    <Link href={urls.contact.general}>
                        {t('contacts.general')}
                    </Link>
                    <Link href={urls.contact.media}>
                        {t('contacts.media')}
                    </Link>
                    <Link href={urls.contact.jobs}>
                        {t('contacts.jobs')}
                    </Link>
                    <Link href={urls.contact.business}>
                        {t('contacts.business')}
                    </Link>
                </FooterColumn>
                <FooterColumn title="Legal">
                    <Link newTab href={urls.documents.terms}>
                        {t('general.terms')}
                    </Link>
                    <Link newTab href={urls.documents.privacy}>
                        {t('general.privacy')}
                    </Link>
                </FooterColumn>
            </FooterColumns>
            <SocialChannels />
            <NewsletterSignUp
                formId={process.env.GATSBY_HUBSPOT_NEWSLETTER_FORM_ID}
                portalId={process.env.GATSBY_HUBSPOT_NEWSLETTER_PORTAL_ID}
                onSuccess={onSuccess}
                // Using `key` to remount the form after successful submission.
                // See `onSuccess` for details.
                key={submissionCount}
                title={(
                    <>
                        <Display as="span" mobile="none" tablet="inline">
                            Subscribe to the Streamr newsletter
                        </Display>
                        <Display as="span" tablet="none">
                            Subscribe to the newsletter
                        </Display>
                    </>
                )}
            />
            <NewsletterSignUpConfirmation
                open={confirmationOpen}
                imageUrl={newsletterConfirmation}
                onCloseClick={closeConfirmation}
            />
        </LayoutFooter>
    )
}

const Footer = styled(UnstyledFooter)`
    color: #0C009A;

    ${SocialChannels} {
        svg {
            path {
                fill: #0C009A;
            }
        }
    }

    @media (min-width: ${TABLET}px) {
        ${SocialChannels},
        ${NewsletterSignUp} {
            margin-left: auto;
            margin-right: auto;
            max-width: 584px;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        ${SocialChannels},
        ${NewsletterSignUp} {
            max-width: none;
        }
    }
`

export default Footer
